
export default {
  name: "ArticleCardNew",

  props: {
    article: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  computed: {
    imagePath: function () {
      return this.$img(String(this.article.image_id))
    }
  }
}
